__turbopack_context__.v({
  "article": "wiki-view-module__oLml6W__article",
  "breadcrumbs": "wiki-view-module__oLml6W__breadcrumbs",
  "caption": "wiki-view-module__oLml6W__caption",
  "figure": "wiki-view-module__oLml6W__figure",
  "figureLeft": "wiki-view-module__oLml6W__figureLeft",
  "figureSide": "wiki-view-module__oLml6W__figureSide",
  "navbox": "wiki-view-module__oLml6W__navbox",
  "navboxList": "wiki-view-module__oLml6W__navboxList",
  "navboxTitle": "wiki-view-module__oLml6W__navboxTitle",
  "related": "wiki-view-module__oLml6W__related",
  "relatedTypes": "wiki-view-module__oLml6W__relatedTypes",
  "thumbnail": "wiki-view-module__oLml6W__thumbnail",
});
